import { useCallback, useEffect, useState } from 'react'
import { api } from '@/runtime'
import { parseTranscript, type Transcript } from './transcript'

type State = { transcript?: Transcript; error?: string }

/**
 * A session's full transcript, read once something asks for it (`want`) and again
 * whenever `tick` moves (a new line arrived), never before: it is long, online only
 * and not synced. A failed read keeps what was read before and says why.
 */
export const useTranscript = (name: string, want: boolean, tick: number) => {
  const [state, setState] = useState<State>({})
  const [retry, setRetry] = useState(0)
  useEffect(() => {
    if (!want || !name) return
    let stale = false
    api
      .factoryTranscript(name)
      .then(({ lines }) => {
        if (!stale) setState({ transcript: parseTranscript(lines) })
      })
      .catch((e: Error) => {
        if (!stale) setState((s) => ({ ...s, error: e.message || 'It did not answer' }))
      })
    return () => {
      stale = true
    }
  }, [name, want, tick, retry])
  const again = useCallback(() => setRetry((n) => n + 1), [])
  // nothing read and nothing failed yet: the first read is on its way
  return { ...state, loading: want && !state.transcript && !state.error, again }
}
